<ng-template #loading>
    <edp-loader [size]="'md'" class="text-center my-auto"></edp-loader>
</ng-template>

<form
    [formGroup]="consumptionsForm"
    (ngSubmit)="onSubmit()"
    class="h-100 p-0
    d-flex flex-column"
    *ngIf="activeMetersElectricity; else loading"
>
    <div class="form-row">
        <ng-container *ngFor="let meter of activeMetersElectricity?.meters" [ngSwitch]="meter.RegisterType">
            <div class="form-group col-4 mb-0" *ngSwitchCase="RegisterTypeEnum[RegisterTypeEnum.S]">
                <label class="font-weight-bold">{{ "pt.edp.edponline.consumptionType.S" | translate }}</label>
                <input
                    type="text"
                    inputmode="numeric"
                    min="0"
                    class="form-control custom-input"
                    formControlName="typeS"
                    [ngClass]="{
                        'input-alert': meter.OutsideConsumption,
                        'input-error': consumptionsForm.controls['typeS'].invalid && !consumptionsForm.controls['typeS'].errors?.required
                    }"
                    (change)="consumptionsFormChange($event, meter)"
                    (focus)="onFocus(meter)"
                    (blur)="onBlur()"
                />
                <small class="form-text" *ngIf="activeMetersElectricity.lastInserted?.S && !noConsumptionData">
                    {{ "pt.edp.edponline.last" | translate }} :
                    {{ activeMetersElectricity.lastInserted.S }}
                </small>
            </div>
            <div class="form-group col-4 mb-0" [ngClass]="{ 'col-5': !isTwoReaders }" *ngSwitchCase="RegisterTypeEnum[RegisterTypeEnum.FV]">
                <div class="d-block custom-label-wrapper" [ngClass]="{ 'd-flex': !isTwoReaders }">
                    <label class="font-weight-bold custom-label">{{ "pt.edp.edponline.consumptionType.FV" | translate }}</label>
                    <p class="label-helper">
                        <ng-container *ngIf="isTwoReaders">{{ readingCode.FV }} |</ng-container>
                        <i class="icon-edponline-Bop-027" [ngClass]="{ 'ml-1': !isTwoReaders }"></i>
                    </p>
                </div>
                <input
                    type="text"
                    inputmode="numeric"
                    min="0"
                    class="form-control custom-input"
                    formControlName="typeFV"
                    [ngClass]="{
                        'input-alert': meter.OutsideConsumption,
                        'input-error': consumptionsForm.controls['typeFV'].invalid && !consumptionsForm.controls['typeFV'].errors?.required
                    }"
                    (change)="consumptionsFormChange($event, meter)"
                    (focus)="onFocus(meter)"
                    (blur)="onBlur()"
                />
                <small class="form-text" *ngIf="activeMetersElectricity.lastInserted?.FV && !noConsumptionData">
                    {{ "pt.edp.edponline.last" | translate }} :
                    {{ activeMetersElectricity.lastInserted.FV }}
                </small>
            </div>
            <div class="form-group col-4 mb-0" [ngClass]="{ 'col-5': !isTwoReaders }" *ngSwitchCase="RegisterTypeEnum[RegisterTypeEnum.V]">
                <div class="d-block w-100 custom-label-wrapper" [ngClass]="{ 'd-flex': !isTwoReaders }">
                    <label class="font-weight-bold custom-label">{{ "pt.edp.edponline.consumptionType.V" | translate }}</label>
                    <p class="label-helper">
                        <ng-container *ngIf="isTwoReaders">{{ readingCode.V }} |</ng-container>
                        <i class=" icon-edponline-Bop-028" [ngClass]="{ 'ml-1': !isTwoReaders }"></i>
                    </p>
                </div>
                <input
                    type="text"
                    inputmode="numeric"
                    min="0"
                    class="form-control custom-input"
                    formControlName="typeV"
                    [ngClass]="{
                        'input-alert': meter.OutsideConsumption,
                        'input-error': consumptionsForm.controls['typeV'].invalid && !consumptionsForm.controls['typeV'].errors?.required
                    }"
                    (change)="consumptionsFormChange($event, meter)"
                    (focus)="onFocus(meter)"
                    (blur)="onBlur()"
                />
                <small class="form-text" *ngIf="activeMetersElectricity.lastInserted?.V && !noConsumptionData">
                    {{ "pt.edp.edponline.last" | translate }} :
                    {{ activeMetersElectricity.lastInserted.V }}
                </small>
            </div>
            <div class="form-group col-4 mb-0" [ngClass]="{ 'col-5': !isTwoReaders }" *ngSwitchCase="RegisterTypeEnum[RegisterTypeEnum.P]">
                <div class="d-block w-100 custom-label-wrapper" [ngClass]="{ 'd-flex': !isTwoReaders }">
                    <label class="font-weight-bold custom-label">{{ "pt.edp.edponline.consumptionType.P" | translate }}</label>
                    <p class="label-helper">
                        <ng-container *ngIf="isTwoReaders">{{ readingCode.P }} |</ng-container>
                        <i class="icon-edponline-Bop-132-2" [ngClass]="{ 'ml-1': !isTwoReaders }"></i>
                    </p>
                </div>
                <input
                    type="text"
                    inputmode="numeric"
                    min="0"
                    class="form-control custom-input"
                    formControlName="typeP"
                    [ngClass]="{
                        'input-alert': meter.OutsideConsumption,
                        'input-error': consumptionsForm.controls['typeP'].invalid && !consumptionsForm.controls['typeP'].errors?.required
                    }"
                    (change)="consumptionsFormChange($event, meter)"
                    (focus)="onFocus(meter)"
                    (blur)="onBlur()"
                />
                <small class="form-text" *ngIf="activeMetersElectricity.lastInserted?.P && !noConsumptionData">
                    {{ "pt.edp.edponline.last" | translate }} :
                    {{ activeMetersElectricity.lastInserted.P }}
                </small>
            </div>
            <div class="form-group col-4 mb-0" [ngClass]="{ 'col-5': !isTwoReaders }" *ngSwitchCase="RegisterTypeEnum[RegisterTypeEnum.C]">
                <div class="d-block w-100 custom-label-wrapper" [ngClass]="{ 'd-flex': !isTwoReaders }">
                    <label class="font-weight-bold custom-label">{{ "pt.edp.edponline.consumptionType.C" | translate }}</label>
                    <p class="label-helper">
                        <ng-container *ngIf="isTwoReaders">{{ readingCode.C }} |</ng-container>
                        <i class=" icon-edponline-Bop-027" [ngClass]="{ 'ml-1': !isTwoReaders }"></i>
                    </p>
                </div>
                <input
                    type="text"
                    inputmode="numeric"
                    min="0"
                    class="form-control custom-input"
                    formControlName="typeC"
                    [ngClass]="{
                        'input-alert': meter.OutsideConsumption,
                        'input-error': consumptionsForm.controls['typeC'].invalid && !consumptionsForm.controls['typeC'].errors?.required
                    }"
                    (change)="consumptionsFormChange($event, meter)"
                    (focus)="onFocus(meter)"
                    (blur)="onBlur()"
                />
                <small class="form-text" *ngIf="activeMetersElectricity.lastInserted?.C && !noConsumptionData">
                    {{ "pt.edp.edponline.last" | translate }} :
                    {{ activeMetersElectricity.lastInserted.C }}
                </small>
            </div>
        </ng-container>
        <ng-container *ngIf="showAlertMessage && !isTypeMeterError">
            <small class="message-alert mt-2">
                {{ "pt.edp.edponline.dashboard.widget.consumptions.outSideConsumptions" | translate }}
            </small>
        </ng-container>
        <ng-container *ngIf="isTypeMeterError">
            <small class="message-error mt-2">{{ "pt.edp.edponline.dashboard.widget.consumptions.error" | translate }}</small>
        </ng-container>
    </div>
    <div class="form-row mb-2 pt-4 mt-auto form-btn">
        <div *ngIf="voiceAvailable" class="form-group col-3 mb-0" [ngClass]="voiceAvailable ? 'd-lg-block' : 'd-lg-none'">
            <div class="btn icon-mic p-0 d-flex align-items-center justify-content-center">
                <i class="icon-edponline-Bop-171 icon-2x" (click)="showVoiceModal()" aria-hidden="true"></i>
            </div>
        </div>

        <div class="form-group mb-0 d-flex justify-content-center" [ngClass]="voiceAvailable ? 'col-9' : 'col-12'">
            <button impersonateDisable [disabled]="!consumptionsForm.valid || isSubmitted" class="btn btn-primary w-75">
                <span *ngIf="!activeMetersElectricity.updateReadingInTime && !activeMetersElectricity.updateReadingOutTime">
                    {{ "ContractReadings.sendreading" | translate }}
                </span>
                <span *ngIf="activeMetersElectricity.updateReadingInTime || activeMetersElectricity.updateReadingOutTime">
                    {{ "pt.edp.edponline.dashboard.widget.consumptions.updateConsumptions" | translate }}
                </span>
            </button>
        </div>
    </div>
</form>
